var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73281 17.8834C7.25008 16.8645 8.03937 16.0088 9.0132 15.411C9.98703 14.8133 11.1074 14.4969 12.25 14.4969C13.3926 14.4969 14.513 14.8133 15.4868 15.411C16.4606 16.0088 17.2499 16.8645 17.7672 17.8834M20.5 11.75C20.5 16.3063 16.8063 20 12.25 20C7.69365 20 4 16.3063 4 11.75C4 7.19365 7.69365 3.5 12.25 3.5C16.8063 3.5 20.5 7.19365 20.5 11.75ZM15.6875 11.0625C15.6875 12.961 14.1485 14.5 12.25 14.5C10.3515 14.5 8.8125 12.961 8.8125 11.0625C8.8125 9.16402 10.3515 7.625 12.25 7.625C14.1485 7.625 15.6875 9.16402 15.6875 11.0625Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.a840d2aecf8c6e1f2c4f1d277f624794.svg";
export { ForwardRef as ReactComponent };